<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <h2 class="modal-card-title">
        Delete user
      </h2>
      <button class="modal-close is-large" @click="onCancel"></button>
    </header>
    <section class="modal-card-body">
      <i class="warning-icon fa fa-exclamation-circle"></i>
      <p>
        Removed user will not have access to your account.
        <br>
        Are you sure you want to delete the user
        <b>
          {{ user.firstname }} {{ user.lastname }} ({{ user.email }})
        </b>
        ?
      </p>
    </section>
    <footer class="modal-card-foot buttons is-right">
      <button class="button button-cancel" type="button" @click="onCancel">
        Cancel
      </button>
      <button class="button is-danger" @click="onConfirm">
        delete
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'CardTeamManagementDeleteConfirmation',
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
    };
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped lang="stylus">
button.button
  width 135px
  height 46px
  border 1px solid #23D160
  font-size 19px
  text-transform uppercase
.button.button-cancel
  color #23D160
.button.button-cancel:hover
  background #17b548
  color white
.button.is-danger
  border none

.modal-card .modal-card-title
  font-weight 600
  margin-bottom unset

.modal-close
  top 16px

.modal-card-foot
  border none
  background-color white

p
  margin-bottom 20px
  width calc(100% - 55px)
  overflow-wrap break-word
.buttons
  @media(max-width:326px)
    flex-direction: column
    .button
      width 100%

.modal-card-body
  display flex
  align-items start
  .warning-icon
    color #DE4B4B
    font-size 45px
    margin-right 10px
footer
  padding-top 0
</style>

<style lang="stylus">
.team-management-delete-confirmation
  .animation-content
    width 470px
  .modal-card
    width 100% !important
</style>
